<template>
  <SheetContainer title="音量" desc="设置音量大小,对全文生效">
    <div class="sheet-list">
      <div @click="addVolume(-1)" class="reduce"><van-icon name="minus" /></div>
      <div class="relative">
        <div class="value-popup" :style="`left:${valuePopLeft}rem`">
          <span class="value-btn">{{ parseInt(volumeValue) }}%</span>
        </div>
        <div class="slider">
          <van-slider  @change="changeVolume" v-model="volumeValue" :step="1" :min="0" :max="100" />
        </div>

        <ul class="volume-list">
          <li v-for="item in volumeValueList" :key="item" :style="`left:${0.0590 * item}rem`">
            {{ item }}
          </li>
        </ul>
      </div>
      <div @click="addVolume(1)" class="add"><van-icon name="plus" color="#333" /></div>
    </div>
    <div class="btn">
      <span :class="['sheet-item',commitRemovable?'checked':'']" @click="onSelect">确定</span>
      <span :class="['sheet-item',removable?'removable':'remove']" @click="onRemoveClick">
        恢复默认
      </span>
    </div>
  </SheetContainer>
</template>
<style lang="less" scoped>
.sheet-desc{
    margin-bottom:46px;
}
.sheet-content {
  .add,
  .reduce {
    color: #333;
    width: 30px;
    outline: #ffffff;
    .van-icon {
      font-size: 30px !important;
      margin-top: 73px !important;
    }
  }
  .sheet-list {
    display: flex;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    padding-top:4px;
    .reduce {
      .van-icon {
        margin-top: 66px;
        font-size: 44px;
        font-weight: 1000;
      }
    }
    .relative {
      position: relative;
   
      text-align: center;
      .value-popup {
        position: absolute;
        transform: translate(-50%);
        box-sizing: border-box;
        width: 96px;
        text-align: center;
        height: 44px;
        background: #ffffff;
        box-shadow: 0px 3px 14px 0px rgba(130, 183, 205, 0.56);
        border-radius: 22px;
        font-size: 28px;
        font-family: 'HarmonyOS_Sans_SC_Medium';
        color: #515b75;
        line-height: 46px;
        .value-btn{
            margin-top:4px;
        }
      }
      .slider {
        width: 590px;
        // margin: 85px 0 0 16px;
        margin:0 auto;
        margin-top: 85px;
      }
      .volume-list {
        // width: 628px;
        width:590px;
        position: relative;
        margin-top: 20px;
        height: 100px;
        margin-right:0px;
        li {
          display: inline-block;
          transform: translate(-50%);
          position: absolute;
          font-size: 24px;
          font-family: 'HarmonyOS_Sans_SC';
          font-weight: 400;
          color: #999999;
          line-height: 33px;
        }
      }
    }
    .add {
      .van-icon {
        margin-top: 66px;
        font-size: 44px;
        font-weight: 1000;
      }
    }
  }
  .btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .sheet-item {
      text-align: center;
      line-height: 64px;
      display: block;
      width: 320px;
      height: 64px;
      border-radius: 10px;
      margin-right: 0px;
      &.removable {
        background: #dceafe;
        border-color: #dceafe;
        color: #333333;
      }
    }
  }
}
</style>
<script>
import vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import SheetContainer from '../sheet-container/sheet-container.vue';
import { customCollectEvent } from '@/utils/collect';
@Component({
  components: {
    SheetContainer,
  },
})
export default class LocalVolumeSheet extends vue {
  @Prop({value:''}) lastVolumeValue//该用户上一次的音量值
  volumeValueList = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]; // 预置的音量
  volumeValue = 70;
  commitRemovable = false;//确定按钮是否可以点击(音量没有改变不可点击)
  mounted(){
    this.volumeValue = this.lastVolumeValue;
  }
  //是否可以恢复默认设置
  get removable() {
    return this.volumeValue !=70 ;
  }
  get valuePopLeft() {
    return 0.0596 * this.volumeValue;
  }
  changeVolume(newValue){
    this.commitRemovable = newValue != this.lastVolumeValue;
  }
  onSelect() {
    //设置音量逻辑-保存当前全局音量
    this.updateValue(this.volumeValue)
  }
  onRemoveClick() {
    if(this.volumeValue!=70){
      this.volumeValue = 70;
      this.updateValue(70)
    }
  }
  addVolume(step) {
    if (
      (this.volumeValue > 0 && this.volumeValue < 100) ||
      (this.volumeValue == 0 && step > 0) ||
      (this.volumeValue == 100 && step < 0)
    ) {
      this.volumeValue += step;
    }
  }
  updateValue(newValue) {
    if (newValue != this.lastVolumeValue) {
    //   localStorage.setItem('volume',newValue)
      this.$emit('change', newValue);
      if (newValue) {
        //添加埋点
        customCollectEvent('editor_volume', {
          time: +newValue,
        });
      }
    }
  }
}
</script>
